<h2 mat-dialog-title>
    {{ 'polls_settings.aggregate_results_dialog.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10 poll-aggregated-results">
    @if(loading){
        <p class="text-secondary pb-3"><i class="fa-solid fa-circle-notch fa-spin"></i> {{ 'polls_settings.loading' | translate}}</p>
    } @else {
        <div class="row pb-5 px-5">
            <h3 class="col-md-8 mx-auto text-center text-secondary fw-normal fst-italic fs-5 py-3">
                {{poll?.label}}
            </h3>
            <div class="col-md-7 d-flex flex-column justify-content-center align-items-center">
                @if(poll?.teams?.length > 1){
                    <p class="text-center text-secondary fw-bold">{{ 'polls_settings.aggregate_results_dialog.subtitle' | translate}}</p>
                }
                @if(poll?.aggregatedResults?.results?.values){
                    <poll-results-chart [results]="$safeNavigationMigration(poll?.aggregatedResults.results)"
                                        [pollType]="$safeNavigationMigration(poll?.aggregatedResults.pollType)"
                                        [pollId]="$safeNavigationMigration(poll?.aggregatedResults.pollType)"
                                        [context]="'dialog'"></poll-results-chart>
                }
            </div>
            <div class="col-md-5 d-flex flex-column justify-content-center align-items-center"
                 [ngClass]="{'pt-3': (poll?.teams?.length === 1 && hasComments($safeNavigationMigration(poll?.aggregatedResults?.results?.values)))}">
                <div class="alert alert-light p-4">
                    <p class="pb-3">
                        {{ 'polls_settings.aggregate_results_dialog.question_asked' | translate }} @if(poll?.displayAuthor){
                        {{ 'by' | translate }} <span class="fst-italic">{{poll?.author.fullname}}</span>
                        } 
                        {{'polls_settings.aggregate_results_dialog.target' | translate}}<br>
                        @for(team of poll.teams; track $index){
                            @if($index < 3){
                                <span class="badge border text-bg-light my-1 ms-0 me-2">{{team.teamName}}</span> 
                            }                         
                        }
                        @if(poll?.teams.length > 3){
                            @if(!showMore){
                                <small class="text-link" (click)="showMore = true" >{{poll.teams.length - 3}} {{'polls_settings.show_more' | translate}}</small>
                            }@else{
                                @for(team of poll.teams; track $index){
                                    @if($index >= 3){
                                            <span class="badge border text-bg-light my-1 ms-0 me-2">{{team.teamName}}</span> 
                                    }                         
                                }
                                <small  class="d-block text-link text-center" (click)="showMore = false">
                                    <i class="fa-solid fa-chevron-up pe-1"></i>{{'polls_settings.show_less' | translate}}
                                </small>
                            }
                        }
                    </p>
                    <p class="pb-3">
                        <i class="fa-regular fa-calendar-days pe-2"></i>{{ 'from' | translate }} <span class="fst-italic">{{$safeNavigationMigration(poll?.startDate) | date}}</span> {{ 'to' | translate }} <span class="fst-italic">{{$safeNavigationMigration(poll?.endDate) | date}}</span>
                    </p>
                    <p class="">
                        <i class="fa-regular fa-users pe-2"></i>{{'polls_settings.aggregate_results_dialog.participation' | translate:{'participation': $safeNavigationMigration(poll?.aggregatedResults?.participation), 'teamsSize':$safeNavigationMigration(poll?.aggregatedResults?.teamsSize)} }}
                    </p>
                </div>
                <div>
                    @if(hasComments($safeNavigationMigration(poll?.aggregatedResults?.results.values)) && poll?.teams?.length === 1){
                        <p class="pt-2 text-secondary">{{ 'polls_settings.aggregate_results_dialog.comments' | translate: ({count: commentCount($safeNavigationMigration(poll?.aggregatedResults?.results?.values))}) }}</p>
                        <div class="all-comments pt-2">
                            <div class="pb-4">
                                <poll-result-comments [commentResults]="$safeNavigationMigration(poll?.aggregatedResults?.results?.values)"
                                                    [itemType]="convertPollTypeIntoTimelineItemType($safeNavigationMigration(poll?.aggregatedResults?.pollType))"></poll-result-comments>
                            </div>
                        </div>
                        <p class="pt-2">
                            <a href="{{poll?.teams[0]?.timelineItemLink}}" target="_blank">
                                {{ 'polls_settings.see_in_timeline'| translate}}<i class="fa-solid fa-up-right-from-square ps-1"></i>
                            </a>
                        </p>
                    }
                </div>
            </div>
        </div>
   
<!-- Details tabs -->
        @if(poll?.teams?.length > 1){
        <div class="mx-3 details-divider">
            <p class="fst-italic text-secondary pb-2">{{'polls_settings.aggregate_results_dialog.details'| translate}}</p>
        </div>
        <div class="tabs-wrapper">
            <mat-tab-group>
                <!-- Details by Team -->
                                <mat-tab label="{{'polls_settings.aggregate_results_dialog.byteam' | translate}}"> 
                                    <ng-template matTabContent>
                                        <div class="row pt-3">
                                            @if(poll?.teams?.length !== 0){
                                                @for(team of poll?.teams; track team.teamId){
                                                    <div class="col-md-4">
                                                        <p class="fw-bold text-center text-secondary">
                                                            {{team.teamName}}
                                                            <a class="ps-1" href="{{team.timelineItemLink}}" target="_blank"
                                                                matTooltip="{{ 'polls_settings.see_in_timeline'| translate}}">
                                                                <i class="fa-solid fa-up-right-from-square"></i>
                                                            </a>
                                                        </p>
                                                        @if(team.results?.values){
                                                        <poll-results-chart [results]="team.results"
                                                                            [pollType]="team.pollType"
                                                                            [pollId]="team.teamId"></poll-results-chart>
                                                        }
                                                    </div>
                                                }
                                            }
                                        </div>
                                    </ng-template>
                                </mat-tab>    
                <!-- Details by Team with comments -->
                                @if(hasComments($safeNavigationMigration(poll?.aggregatedResults?.results?.values)) && poll?.teams.length > 1){
                                <mat-tab label="{{'polls_settings.aggregate_results_dialog.bycomments' | translate}}" 
                                        [disabled]="!hasComments($safeNavigationMigration(poll?.aggregatedResults?.results?.values))">
                                    <ng-template matTabContent>
                                        <div class="charts-with-comments pt-3">
                                            @if(poll?.teams.length !== 0){
                                                @for(team of poll?.teams; track team.teamId){
                                                    @if(team.results?.values){
                                                        <div class="px-5 py-3 chart-with-comments">
                                                            <p class="fw-bold text-center text-secondary pb-2">
                                                                {{team.teamName}}
                                                                <a class="ps-1" [attr.target]="'_blank'"
                                                                [routerLink]="['/home', team.teamId, {fragment: team.pollId}]"
                                                                [matTooltip]="'polls_settings.see_in_timeline' | translate "
                                                                    matTooltipPosition="above">
                                                                    <i class="fa-solid fa-up-right-from-square"></i>
                                                                </a>
                                                            </p>
                                                            <div>
                                                                <poll-results-chart [results]="team.results" 
                                                                        [pollType]="team.pollType"
                                                                        [pollId]="team.teamId+'-comments'"></poll-results-chart>
                                                            </div>
                                                            <div class="py-4">
                                                                <poll-result-comments [commentResults]="team.results.values"
                                                                                    [itemType]="convertPollTypeIntoTimelineItemType(team.pollType)"></poll-result-comments>
                                                            </div>
                                                        </div>
                                                    }
                                                }
                                            }
                                        </div>
                                    </ng-template>
                                </mat-tab>
                                }
                <!-- All comments -->
                                <mat-tab [label]="hasComments(poll?.aggregatedResults.results.values)?translate.instant('polls_settings.aggregate_results_dialog.allcomments', {count: commentCount(poll?.aggregatedResults.results.values)}):translate.instant('polls_settings.aggregate_results_dialog.nocomments')" [disabled]="!hasComments(poll?.aggregatedResults.results.values)">
                                    <div class="all-comments pt-3">
                                        <div class="pb-4">
                                            <poll-result-comments [commentResults]="poll?.aggregatedResults.results.values"
                                                                [itemType]="convertPollTypeIntoTimelineItemType($safeNavigationMigration(poll?.aggregatedResults.pollType))"></poll-result-comments>
                                        </div>
                                    </div>
                                </mat-tab>
                    </mat-tab-group>   
                </div> 
        }
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'close' | translate}}</button>
</mat-dialog-actions>